import React, { useState, Fragment, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { postAPI_Create_Location, gAPI_Location_By_Id, putAPI_Update_Location, putAPI_Delete_Location } from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
export function AddNewService({
    id,
    visible,
    toggleModal,
    formLabel,
    propertyId
}) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const [locationData, setLocationData] = useState({
        groupId: getGroupID(),
        propertyId: propertyId,
        name: '',
        address: '',
        city: '',
        openingHours: '',
        websiteLink: '',
        email: '',
        phone: '',
        status: 'Active',
        creator: 'dashboard'
    });

    useEffect(() => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Location_By_Id}/${id}`,
            })
                .then(res => {
                    setLocationData(res.data)
                })
                .catch(err => console.log('err', err));
        }
    }, [id]);

    const handleChange = e => {
        setLocationData({
            ...locationData,
            [e.target.name]: e.target.value,
        });
    };

    const handleDelete = () => {
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Delete_Location}/${id}`,
            data: {
                deleter: 'dashboard'
            },
        })
            .then(res => {
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            })
            .catch(err => {
                console.log(err);
            });
    };

    const generateDeleteButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This location will be deleted!
                                </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        <IntlMessages id='dashboards.delete' />
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        <IntlMessages id='pages.cancel' />
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const handleSubmit = () => {
        if (id !== undefined) {
            const formmatedData = { ...locationData, Updater: 'admin' };
            AxiosAPI({
                method: 'put',
                url: `${putAPI_Update_Location}/${id}`,
                data: formmatedData,
            })
                .then(res => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsg(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    }
                }
                )
                .catch(err => {
                    console.log('err', err);
                });
        }
        else {
            const formmatedData = { ...locationData };
            AxiosAPI({
                method: 'post',
                url: `${postAPI_Create_Location}`,
                data: formmatedData,
            })
                .then(res => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsg(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    }
                }

                )
                .catch(err => {
                    console.log('err', err);
                });
        }
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggleModal} wrapClassName="modal-right"
                backdrop="static">
                <ModalHeader toggle={toggleModal}>{formLabel}</ModalHeader>
                {locationData != undefined && (
                    <ModalBody>
                        {/* <pre>{JSON.stringify(serviceData, null, 2)}</pre> */}
                        <Label className="mt-3">
                            Name
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={locationData.name}
                            name="name"
                        />
                        <Label className="mt-3">
                            Address
                        </Label>

                        <Input
                            type="textarea"
                            onChange={handleChange}
                            value={locationData.address}
                            name="address"
                        />
                        <Label className="mt-3">
                            Status
                        </Label>
                        <Input
                            type="select"
                            name="status"
                            value={locationData.status}
                            onChange={handleChange}
                        >
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </Input>
                        <Label className="mt-3">
                            City
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={locationData.city}
                            name="city"
                        />
                        <Label className="mt-3">
                            Opening Hours
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={locationData.openingHours}
                            name="openingHours"
                        />
                        <Label className="mt-3">
                            Website
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={locationData.websiteLink}
                            name="websiteLink"
                        />
                        <Label className="mt-3">
                            Email
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={locationData.email}
                            name="email"
                        />
                        <Label className="mt-3">
                            Phone
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={locationData.phone}
                            name="phone"
                        />

                    </ModalBody>)}
                <ModalFooter>
                    <Button color="primary" onClick={handleSubmit}>
                        <IntlMessages id='dashboards.save' />
                    </Button>
                    <Button color="secondary" onClick={toggleModal}>
                        <IntlMessages id='pages.cancel' />
                    </Button>
                    {id && (<Button color="danger" onClick={toggle}>
                        <IntlMessages id='dashboards.delete' />
                    </Button>)}

                </ModalFooter>
            </Modal>
            {generateDeleteButton()}
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment >
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps, {})(AddNewService));